import MobileMainLayout from '../../layout/Mobile/MobileMainLayout'
import MobileTicketsPageLayout from '../../layout/Mobile/MobileTicketsPageLayout'

const MobileTicketsPage = () => {
    return (
        <>
            <MobileMainLayout >
                <MobileTicketsPageLayout />
            </MobileMainLayout>
        </>
    )
}

export default MobileTicketsPage
